export const alert = function (options) {
  if (typeof options === 'string') {
    return window.alert(options)
  }
  if (options && typeof options.title === 'string') {
    return window.alert(options.title)
  }
  window.alert(options)
}



// WEBPACK FOOTER //
// ./src/npm/monitor/platform/h5/modal.js